module.exports = __webpack_public_path__ + "static/img/15.d6e5eb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/15.jpg
// module id = 9ndc
// module chunks = 1